"use strict";

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');
var assert = require('bunsen/helpers/assert');

// ---------------------------------------------------
// Module Definition and Static Properties

/**
 * @module stringNumHelper
 * @type {object}
 */
var stringNumHelper = module.exports = {

    /**
     * @param {string} val
     * @returns {boolean}
     */
    strValHasValidCommaSegmentLength: function (val) {
        assert(typeof val === 'string', 'val must be a string');
        val = val.replace('-', '');
        var dotIndex = val.indexOf('.');
        var segs;
        val = dotIndex > -1 ? val.substr(0, dotIndex) : val;
        segs = val.split(',');
        return _.every(segs, function (seg, index) {
            var len = seg.length;
            return (index === 0 && len < 4 && len > 0) || len === 3;
        });
    },

    /**
     * @param {string} strVal
     * @returns {string}
     */
    stripCommas: function (strVal) {
        return strVal.replace(/,/g, '');
    },

    /**
     * Same as Number(stringVal) but removes commas
     * from the string val first. This conversion
     * function will convert '' into 0. If you do
     * not want this, use safeConvertNumberVal.
     *
     * @param {string} strVal
     * @returns {number}
     */
    convertStrToNumber: function (strVal) {
        assert(typeof strVal === 'string', 'val must be a string');
        strVal = stringNumHelper.stripCommas(strVal);
        return Number(strVal);
    },

    /**
     * @param val
     * @returns {boolean}
     */
    strNumHasNoLeadingZeroes: function (val) {
        assert(typeof val === 'string', 'val must be a string');
        return (val === '0' || val.charAt(0) !== '0' || val.charAt(1) === '.');
    },

    /**
     * Like $.isNumeric, except this function
     * allows commas.
     * @param {string} val
     * @param {boolean} [strictCommas=false]
     * @returns {boolean}
     */
    strValIsNumeric: function (val, strictCommas) {
        assert(typeof val === 'string', 'val must be a string');
        if (strictCommas && val.indexOf(',') > -1 && !stringNumHelper.strValHasValidCommaSegmentLength(val)) {
            return false;
        }
        if (this.checkIsEmptyVal(val)) {
            return false;
        }
        var numVal = stringNumHelper.convertStrToNumber(val);
        return !isNaN(numVal) && isFinite(numVal) && stringNumHelper.strNumHasNoLeadingZeroes(val);
    },

    /**
     * isNaN will return true for NaN and any non-numbers.
     * This function will only return true if you have a
     * number that is actually the NaN constant.
     * @param {*} rawVal
     * @returns {boolean}
     */
    checkIsNaN: function (rawVal) {
        return typeof rawVal === 'number' && isNaN(rawVal);
    },

    /**
     * Return true if the value passed
     * is a number and not NaN
     * @param {*} numberVal
     * @returns {boolean}
     */
    checkIsNonNaNNumber: function (numberVal) {
        return typeof numberVal === 'number' && !isNaN(numberVal);
    },

    /**
     * @param {*} rawVal
     * @returns {boolean}
     */
    checkIsEmptyVal: function (rawVal) {
        return !rawVal && rawVal !== 0;
    },

    /**
     * Takes strings, numbers, and various falsey inputs and
     * returns either a number or null. This is to simplify
     * situations where you can receive numbers, string numbers,
     * or various falsey values (null, '', undefined, NaN). If
     * the value is falsey and not 0, or the parsed string is
     * NaN, then null is returned. Numbers stay the same and
     * string representations are strictly converted (empty
     * string is not converted to 0). Requires valid comma
     * segment lengths if strictCommas flag is true
     *
     * @param {*} rawVal
     * @param {boolean} [strictCommas=false]
     * @returns {number|null}
     */
    safeConvertNumberVal: function (rawVal, strictCommas) {
        if (stringNumHelper.checkIsNonNaNNumber(rawVal)) {
            return rawVal;
        }
        var strVal = String(rawVal);
        if (stringNumHelper.checkIsEmptyVal(rawVal) || !stringNumHelper.strValIsNumeric(strVal, strictCommas)) {
            return null;
        }
        return stringNumHelper.convertStrToNumber(strVal);
    }

};


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/stringNumHelper.js
// module id = 2623
// module chunks = 62